import { theme as o } from "@lokalise/token-dictionary/theme-lokalise-light.js";
import { generateDeprecatedThemeColors as r } from "../designTokens/color/deprecatedColors.js";
const t = (e) => ({
  ...e,
  color: {
    ...e.color,
    deprecated: r("light")
  }
}), p = t(o);
export {
  p as base
};
//# sourceMappingURL=base.js.map
